import {useEffect, useState} from 'react';
import {PageRootModel} from '../../../../generated/core';

/**
 * While a new page loads, the pageRootModel is undefined.
 * This hook provides the last model until the new becomes available.
 * Helpful to keep rendering the topbar based on the old
 * @param model
 * @returns
 */
export const useCurrentOrLastPageRootModel = (
    model?: PageRootModel
): PageRootModel | undefined => {
    const [lastModel, setLastModel] = useState<PageRootModel | undefined>(
        model
    );
    useEffect(() => {
        if (model !== undefined) {
            setLastModel(model);
        }
    }, [model, setLastModel]);

    return lastModel;
};
